<!-- ComboInput.svelte -->
<script>
    import { createEventDispatcher } from 'svelte';
  
    export let options = [];
    export let value = '';
    export let placeholder = '';
  
    let showOptions = false;
    let inputElement;
  
    const dispatch = createEventDispatcher();

    $: filteredOptions = options.filter(option => {
      const optionStr = String(option).toLowerCase();
      const valueStr = String(value).toLowerCase();
      return optionStr.startsWith(valueStr);      
      //console.log('filteredOptions:', optionStr);
    }
      //option.toLowerCase().includes(value.toLowerCase())
    );
  
    function handleInput() {
      showOptions = true;
      dispatch('input', value);
      //console.log('Input handled, showOptions:', showOptions);
    }
  
    function handleSelect(option) {
      value = String(option);;
      showOptions = false;
      dispatch('input', value);
      dispatch('select', value);
      //console.log('Option selected:', value);
    }
  
    function handleBlur() {
      setTimeout(() => {
        showOptions = false;
      }, 200);
    }
  
    function handleFocus() {
      showOptions = true;      
    }

    function clearInput() {
      value = '';
      dispatch('input', value);
      dispatch('select', value);
      inputElement.focus();
    }
  </script>
  
  <div class="combo-input">
    <div class="input-wrapper">
      <input
       class="styled-input"
        bind:this={inputElement}
        bind:value={value}
        on:input={handleInput}        
        on:blur={handleBlur}
        on:focus={handleFocus}
        {placeholder}
      />
      {#if value}
        <button class="clear-button" on:click={clearInput}>×</button>
      {/if}
    </div>
    {#if showOptions && filteredOptions.length > 0}
      <ul class="options">
        {#each filteredOptions as option}
          <li on:mousedown={() => handleSelect(option)}>{option}</li>
        {/each}
      </ul>
    {/if}
  </div>
  
  <style>
    .combo-input {
      position: absolute;
      width: auto;
    }
    input {
      width: 100%;
      padding: 5px;
      padding-right: 10%; /* Make room for the clear button */
      box-sizing: border-box;
    }
    .styled-input::placeholder {
    color: #999; /* Placeholder color */
    font-style: italic; /* Optional: makes the placeholder italic */
    font-size: 12px; /* Adjust size specifically for placeholder */
    transition: opacity 0.3s ease;
    opacity: 0.6;
    }
    .clear-button {
    position: absolute;
    right: 5px;
    top: 40%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #999;
  }
  .clear-button:hover {
    color: #333;
  }
    .options {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      max-height: 200px;
      overflow-y: auto;
      background-color: white;
      border: 1px solid #ccc;
      border-top: none;
      list-style-type: none;
      margin: 0;
      padding: 0;
      z-index: 1000;
    }
    .options li {
      padding: 5px;
      cursor: pointer;
    }  
    .options li:hover {
      background-color: #f0f0f0;
    }
  </style>